const updatePOTGWinners = (state = {}, action) => {
    const { type = null, datasource, data = {} } = action;
    if (type === 'dataEngine_update_response') {
        if (datasource === 'potgWinners') {
            const { winners } = data;
            return { ...state, winners, isLoadingWinners: false };
        }
        if (datasource === 'playerStory') {
            const { playerStories } = data;
            const { winners } = state;
            const updatedWinners = winners?.map((winner) => {
                const { story, hasStory } = playerStories?.[winner.feedId] || winner || {};
                return {
                    ...winner,
                    story,
                    hasStory
                };
            });
            return { ...state, winners: updatedWinners, isLoadingStories: false };
        }
    }
    if (type === 'dataEngine_update_error') {
        if (datasource === 'potgWinners') {
            return { ...state, isLoadingWinners: false };
        }
        if (datasource === 'playerStory') {
            return { ...state, isLoadingStories: false };
        }
    }
    if (type === 'potg_loading') {
        const { isLoadingStories, isLoadingWinners } = data;
        return { ...state, isLoadingStories, isLoadingWinners };
    }

    return state;
};

export default updatePOTGWinners;
